import React from 'react';
import Loader from 'react-loader-spinner';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";

const ResultContainer = (props) => {
    return (
        <div className="container">
            <div className="row">
                <div className="mt-4 mb-4 col-md-12">
                    <h3>Response is available here: </h3>
                    <Loader type="Bars" color="#20c453" height={50} width={50} visible={props.isVisibleLoader}/>
                    <p>{props.data}</p>
                </div>
            </div>
        </div>
    )
};
export default ResultContainer;